export const SEED_CATEGORIES = [
  { id: 'normaal', name: 'Normaal' },
  { id: 'ultra', name: 'Ultra' },
  { id: 'java', name: 'Java' },
  { id: 'icetea', name: 'Ice tea' },
  { id: 'nitro', name: 'Nitro' },
] as const;

/** The owner's own starting catalog (25 flavors); it grows from the app. */
export const SEED_CANS: ReadonlyArray<readonly [category: string, name: string]> = [
  ['normaal', 'Original'],
  ['normaal', 'Lo-Carb'],
  ['normaal', 'Zero Sugar'],
  ['normaal', 'Assault'],
  ['normaal', 'Mango Loco'],
  ['normaal', 'Pipeline Punch'],
  ['normaal', 'Khaotic'],
  ['ultra', 'Ultra White'],
  ['ultra', 'Ultra Paradise'],
  ['ultra', 'Ultra Fiesta'],
  ['ultra', 'Ultra Rosá'],
  ['ultra', 'Ultra Gold'],
  ['ultra', 'Ultra Peachy Keen'],
  ['ultra', 'Ultra Watermelon'],
  ['ultra', 'Ultra Violet'],
  ['ultra', 'Ultra Blue'],
  ['java', 'Mean Bean'],
  ['java', 'Loca Moca'],
  ['java', 'Salted Caramel'],
  ['java', 'Triple Shot'],
  ['icetea', 'Rehab Lemonade'],
  ['icetea', 'Rehab Peach Tea'],
  ['icetea', 'Rehab Raspberry'],
  ['nitro', 'Nitro Super Dry'],
  ['nitro', 'Nitro Cosmic Peach'],
];

/** Whether a can on the wall is the one a zoeklijst line asks for. */
export function fitsWanted(
  want: { canId: number; country: string | null; sizeMl: number | null },
  entry: { canId: number; country: string; sizeMl: number },
): boolean {
  return (
    entry.canId === want.canId &&
    (want.country === null || want.country === entry.country) &&
    (want.sizeMl === null || want.sizeMl === entry.sizeMl)
  );
}

export const SIZES_ML = [250, 355, 473, 500, 553, 568] as const;

export const DUPLICATE_ENTRY_MESSAGE = 'Dit blik staat met hetzelfde land en dezelfde inhoud al in je collectie.';

/** Slugs a user may not take, because they are app routes. */
export const RESERVED_SLUGS = new Set([
  'api',
  'login',
  'mcp',
  'assets',
  'icons',
  'fonts',
  'sw.js',
  'manifest.webmanifest',
  'registerSW.js',
  'workbox',
  'favicon.ico',
  'robots.txt',
]);

export const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;
export const EAN_RE = /^\d{8}$|^\d{12,14}$/;
export const COUNTRY_RE = /^[A-Z]{2}$/;
